import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';
import React from 'react';

import { Box, Flex } from '../grid';
import { P } from '../typography/new';
import { GeneralAllergenPDFLink } from '../general-allergen-pdf-link';

const AllergyInformation = () => {
  const { ProductDetailsState } = useRootStore();

  const {
    orderItem: {
      dietaryDisclaimer,
      formattedContainsString,
      formattedDoesNotContainString,
      formattedNotSuitableFor,
      formattedSuitableFor,
      formattedTracesString,
    },
    isValid,
  } = ProductDetailsState;

  return (
    <>
      <P variant="large-bold">Allergen Information</P>
      {!isValid && (
        <P variant="small">Please make selections in order for nutritional and allergen info to be displayed.</P>
      )}
      {isValid && (
        <>
          <P variant="small">
            Allergens for this item (if any) are listed below. Allergen info does not reflect any customisations made to
            menu items.
          </P>
          {!!formattedSuitableFor && (
            <Flex flexDirection="row">
              <Box width="40%">
                <P textTransform="none" variant="small-semi-bold">
                  Suitable for
                </P>
              </Box>
              <Box width="60%">
                <P variant="small">{formattedSuitableFor}</P>
              </Box>
            </Flex>
          )}
          {!!formattedNotSuitableFor && (
            <Flex flexDirection="row">
              <Box width="40%">
                <P textTransform="none" variant="small-semi-bold">
                  Not Suitable for
                </P>
              </Box>
              <Box width="60%">
                <P variant="small">{formattedNotSuitableFor}</P>
              </Box>
            </Flex>
          )}
          {!!formattedContainsString && (
            <Flex flexDirection="row">
              <Box width="40%">
                <P textTransform="none" variant="small-semi-bold">
                  Contains
                </P>
              </Box>
              <Box width="60%">
                <P variant="small">{formattedContainsString}</P>
              </Box>
            </Flex>
          )}
          {!!formattedDoesNotContainString && (
            <Flex flexDirection="row">
              <Box width="40%">
                <P textTransform="none" variant="small-semi-bold">
                  Does Not Contain
                </P>
              </Box>
              <Box width="60%">
                <P variant="small">{formattedDoesNotContainString}</P>
              </Box>
            </Flex>
          )}
          {!!formattedTracesString && (
            <Flex flexDirection="row">
              <Box width="40%">
                <P textTransform="none" variant="small-semi-bold">
                  May Contain
                </P>
              </Box>
              <Box width="60%">
                <P variant="small">{formattedTracesString}</P>
              </Box>
            </Flex>
          )}
          {!!dietaryDisclaimer && (
            <Flex flexDirection="row">
              <Box width="100%">
                <P variant="small">{dietaryDisclaimer}</P>
              </Box>
            </Flex>
          )}
        </>
      )}
      <GeneralAllergenPDFLink />
    </>
  );
};

const ObservedAllergyInformation = observer(AllergyInformation);
export { ObservedAllergyInformation as AllergyInformation };
